import {
  IspsTruckerChangeTODocumentStatusEnum,
  IspsTruckerChangeTOTerrorStatusEnum,
} from "@/services/api-client/client";

export const terrorStates: IspsTruckerChangeTOTerrorStatusEnum[] = [
  "OK",
  "WARNING",
  "RED_ALERT",
  "MANUALLY_APPROVED",
  "MANUALLY_DENIED",
];

export const idStates: IspsTruckerChangeTODocumentStatusEnum[] = [
  "ACCEPTED",
  "PENDING",
  "DENIED",
  "WARN",
  "DENIED_PRELIMINARY",
  "MANUALLY_APPROVED",
  "MANUALLY_DENIED",
  "FAILED",
];
